document.addEventListener(
    'DOMContentLoaded',
    () => {
        const countdown =
            document.querySelector(
                '[data-meetup-countdown]'
            );

        if (!countdown) {
            return;
        }

        const title =
            countdown.querySelector(
                '[data-meetup-countdown-title]'
            );

        const subtitle =
            countdown.querySelector(
                '[data-meetup-countdown-subtitle]'
            );

        const icon =
            countdown.querySelector(
                '[data-meetup-countdown-icon]'
            );

        const startsAt =
            new Date(
                countdown.dataset.startsAt
            );

        const endsAt =
            countdown.dataset.endsAt
                ? new Date(
                    countdown.dataset.endsAt
                )
                : null;

        const status =
            countdown.dataset.status;

        if (
            !title
            || !subtitle
            || !icon
            || Number.isNaN(
                startsAt.getTime()
            )
        ) {
            return;
        }

        const formatDuration = (
            milliseconds
        ) => {
            const totalMinutes =
                Math.max(
                    0,
                    Math.floor(
                        milliseconds / 60000
                    )
                );

            const days =
                Math.floor(
                    totalMinutes / 1440
                );

            const hours =
                Math.floor(
                    (
                        totalMinutes % 1440
                    ) / 60
                );

            const minutes =
                totalMinutes % 60;

            const parts = [];

            if (days > 0) {
                parts.push(
                    `${days} ${
                        days === 1
                            ? 'day'
                            : 'days'
                    }`
                );
            }

            if (
                hours > 0
                && parts.length < 2
            ) {
                parts.push(
                    `${hours} ${
                        hours === 1
                            ? 'hour'
                            : 'hours'
                    }`
                );
            }

            if (
                minutes > 0
                && parts.length < 2
            ) {
                parts.push(
                    `${minutes} ${
                        minutes === 1
                            ? 'minute'
                            : 'minutes'
                    }`
                );
            }

            return parts.length > 0
                ? parts.join(' ')
                : 'less than a minute';
        };

        const formatDateTime = (
            date
        ) => {
            return date.toLocaleString(
                undefined,
                {
                    dateStyle: 'medium',
                    timeStyle: 'short',
                }
            );
        };

        const updateCountdown = () => {
            const now = new Date();

            if (status === 'cancelled') {
                icon.textContent = '❌';

                title.textContent =
                    'Meetup cancelled';

                subtitle.textContent =
                    'This meetup is no longer taking place.';

                return;
            }

            if (
                status === 'completed'
            ) {
                icon.textContent = '✅';

                title.textContent =
                    'Meetup completed';

                subtitle.textContent =
                    endsAt
                        ? `Ended ${formatDateTime(
                            endsAt
                        )}`
                        : 'This meetup has ended.';

                return;
            }

            if (now < startsAt) {
                const remaining =
                    startsAt.getTime()
                    - now.getTime();

                icon.textContent =
                    remaining <= 15 * 60000
                        ? '🎉'
                        : '⏳';

                title.textContent =
                    `Starts in ${
                        formatDuration(
                            remaining
                        )
                    }`;

                subtitle.textContent =
                    `Scheduled for ${
                        formatDateTime(
                            startsAt
                        )
                    }`;

                return;
            }

            if (
                endsAt
                && now > endsAt
            ) {
                const elapsed =
                    now.getTime()
                    - endsAt.getTime();

                icon.textContent = '✅';

                title.textContent =
                    `Ended ${
                        formatDuration(
                            elapsed
                        )
                    } ago`;

                subtitle.textContent =
                    `Ended ${
                        formatDateTime(
                            endsAt
                        )
                    }`;

                return;
            }

            icon.textContent = '🟢';

            title.textContent =
                'Meetup is happening now';

            subtitle.textContent =
                endsAt
                    ? `Scheduled to end ${
                        formatDateTime(
                            endsAt
                        )
                    }`
                    : 'Check the meetup details and chat for updates.';
        };

        updateCountdown();

        window.setInterval(
            updateCountdown,
            60000
        );
    }
);